module.exports = __webpack_public_path__ + "img/Copyright.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Copyright.svg
// module id = 246
// module chunks = 0